import { render } from "./TiposComprobanteSiiaf.vue?vue&type=template&id=bb2d5ab2"
import script from "./TiposComprobanteSiiaf.vue?vue&type=script&lang=js"
export * from "./TiposComprobanteSiiaf.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__